import { RecentActivities } from '@/interfaces/dashboard/recent-activities';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrderPipe } from 'ngx-order-pipe';
import { TableHeader } from '@/shared/table/table.component';

import { RecentActivitiesService } from '@/services/recent-activities/recent-activities.service';
import { State } from '@/store/login/reducer';
import { map } from 'rxjs/operators';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';

@Component({
  selector: 'app-recent-activities',
  templateUrl: './recent-activities.component.html',
  styleUrls: ['./recent-activities.component.css'],
})
export class RecentActivitiesComponent implements OnInit {

  shouldShowSanctionTypeModal: boolean = false;

  /// togle table

  panelOpenState = false;
  arrowUp: boolean = true;
  arrowDown: boolean = false;
  infoActivity: boolean = false;
  // 'Asset', 'Tipo de Actividad', 'Fecha actividad', 'Nº solicitud', 'Nº licencia', 'Más información'

  headers: TableHeader[] = [
    {
      name: 'Asset',
      key: 'asset',
      isSortable: true,
    },
    {
      name: 'Tipo de Actividad',
      key: 'requirementType',
      isSortable: true,
    },
    {
      name: 'Fecha actividad',
      key: 'createdAt',
      isSortable: true,
    },
    {
      name: 'Nº solicitud',
      key: 'licenseId',
      isSortable: true,
    },
    {
      name: 'Nº licencia',
      key: 'licenseId',
      isSortable: true,
    },
    {
      name: 'Más información',
      key: 'Más información',

    },

  ]

  userData: Partial<State> = {};
  modalData: Partial<RecentActivities> = {};
  constructor(
    private activitiesService: RecentActivitiesService,
    private store: Store<StoreState>,
    private orderPipe: OrderPipe,
  ) {
    getCurrentUserData(this.store).subscribe({
      next: (userData) => {
        this.userData = userData;
      },
    });
    this.activitiesUser = this.activitiesUser.slice();
    this.sortedCollectionActivities = this.orderPipe.transform(this.activitiesUser, 'activitiesUser.id');

  }

  ngOnInit(): void {
    this.getAllActivities();
  }

  activitiesUser: RecentActivities[] = []

  getAllActivities() {
    const userId = this.userData.mdmid;

    if (userId) {
      const requestData = this.activitiesService.getRecentActivities(userId).pipe(
        map(
          (allRows) => allRows
            .map(({ finalizeAt, ...obj }) => ({ ...obj, finalizeAt: '' })),
        ),
      );
      requestData.subscribe((response) => {
        this.activitiesUser = response;
      });
    }
  }

  //  ------> sorting activities  <-------
  orderActivities: string = ''
  reverse: boolean = false;
  sortedCollectionActivities: Partial<RecentActivities[]>;

  order: string = ''
  // 1 -> disabled ; 2 -> asc ; 3 -> desc
  orderStatus: 1 | 2 | 3 = 1;

  setOrder(headerName: string) {
    if (this.order !== headerName) {
      this.orderStatus = 2;
      this.order = headerName;
    }
    else if (this.orderStatus < 3) {
      this.orderStatus++;
    }
    else {
      this.orderStatus = 1;
      this.order = '';
    }

    if (this.orderStatus === 3) {
      this.reverse = true;
    }
    else {
      this.reverse = false;
    }
  }
  getSortingStatusImage(orderStatus: 1 | 2 | 3, arrow: 'UP' | 'DOWN') {
    if (arrow === 'UP') {
      if (orderStatus === 2) {
        return 'assets/img/arrow_r_g.png';
      }
      return 'assets/img/arrow_b_g.png';
    }

    if (orderStatus === 3) {
      return 'assets/img/arrow_r_g.png';
    }
    return 'assets/img/arrow_b_g.png';
  }

  //  ------> paginate activities  <-------

  public config: any = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1,
    totalItems: this.activitiesUser.length,
  };

  public maxSize: number = 30;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public responsive: boolean = true;
  public labels: any = {
    previousLabel: '<',
    nextLabel: '>',
    screenReaderPaginationLabel: 'Pagination',
    screenReaderPageLabel: 'page',
    screenReaderCurrentLabel: 'You\'re on page',
  };

  searchText = '';

  onViewDetail() {
  }

  showSanctionTypeModal(entry: RecentActivities) {
    this.modalData = entry;
    this.shouldShowSanctionTypeModal = true;

  }

  closeSanctionTypeModal() {
    this.modalData = {};
    this.shouldShowSanctionTypeModal = false;
  }
}
